/**
 * This function will be used to modify the way that a Rich Text or Title field is rendered from prismic
 * See: https://prismic.io/docs/reactjs/getting-started/prismic-gatsby
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */

import React from 'react'
import { Elements } from 'prismic-reactjs'
import Link from '../components/Link'

export default (type, element, content, children, index) => {
  // Generate links to Prismic Documents as <Link> components
  if (type === Elements.hyperlink) {
    const target = element.data.target ? { target: element.data.target, rel: 'noopener' } : {}

    return (
      <Link to={element.data} {...target} key={index}>
        {content}
      </Link>
    )
  }

  // If the image is also a link to a Prismic Document, it will return a <Link> component
  if (type === Elements.image) {
    let result = <img src={element.url} alt={element.alt || ''} copyright={element.copyright || ''} />

    if (element.linkTo) {
      const target = element.data.target ? { target: element.data.target, rel: 'noopener' } : {}

      result = (
        <Link to={element.linkTo} {...target} key={index}>
          {content}
        </Link>
      )
    }
    const wrapperClassList = [element.label || '', 'block-img']
    result = (
      <p className={wrapperClassList.join(' ')} key={index}>
        {result}
      </p>
    )
    return result
  }

  // Return null to stick with the default behavior for everything else
  return null
}
